import { PROVIDER } from '../../providers/User/User.model';

export const getTooltipText = (prefix: string, source: PROVIDER, isAuto: boolean): string => {
  return (
    prefix +
    (!isAuto
      ? ' manually entered.'
      : ` from ${source === PROVIDER.PC ? 'PC Miler' : 'Google Maps'}.`)
  );
};
